"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box, FormControlLabel, Radio } from "@mui/material";
import { InputError } from "../../InputError/index.js";
import { INVALID_PROPS_ERROR, MISSING_HELP_LINK_WARNING, MISSING_ARIA_LABEL_PREFIX_WARNING, COMPONENT_NAME } from "./constants.js";
import { SelectorRadioContent } from "./content.js";
import { SelectorRadioButtonStyles } from "./styles.js";
import { Link } from "../../../Navigation/Link/index.js";
import { getDataTestId } from "../../../Util/index.js";
const SelectorRadioButton = (props) => {
  const {
    value,
    title,
    helpLink,
    onChange,
    checked,
    errorText,
    ariaLabelErrorPrefix,
    uniqueId
  } = props;
  const hasError = !!errorText;
  const styles = SelectorRadioButtonStyles({ hasError, isChecked: checked });
  const hasHelpLink = !!helpLink;
  const hasValidHelpLink = (helpLink == null ? void 0 : helpLink.text) && (helpLink == null ? void 0 : helpLink.href);
  if (!value || !title && !uniqueId) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  if (hasHelpLink && !hasValidHelpLink) {
    console.warn(MISSING_HELP_LINK_WARNING);
  }
  if (hasError && !ariaLabelErrorPrefix) {
    console.warn(MISSING_ARIA_LABEL_PREFIX_WARNING);
  }
  const errorTextId = `${COMPONENT_NAME}_${title ? title.replaceAll(" ", "") : uniqueId.replaceAll(" ", "")}_${value}`;
  const errorIconA11yAttributes = {
    "aria-label": `${ariaLabelErrorPrefix}: `,
    "aria-hidden": false,
    focusable: true
  };
  return /* @__PURE__ */ jsxs(Box, { sx: styles.box, children: [
    /* @__PURE__ */ jsx(
      FormControlLabel,
      {
        value,
        control: /* @__PURE__ */ jsx(
          Radio,
          {
            sx: styles.radioButton,
            checked,
            onChange,
            "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
            inputProps: {
              "aria-invalid": hasError,
              "aria-describedby": hasError ? errorTextId : void 0
            }
          }
        ),
        label: /* @__PURE__ */ jsx(SelectorRadioContent, { ...props }),
        sx: styles.formControl
      }
    ),
    /* @__PURE__ */ jsx(
      InputError,
      {
        hasError,
        errorTextId,
        errorIconA11yAttributes,
        errorText
      }
    ),
    hasHelpLink && hasValidHelpLink && /* @__PURE__ */ jsx(
      Link,
      {
        variant: "t7",
        sx: styles.helpLink,
        href: helpLink.href,
        target: helpLink.target || "_self",
        underline: "always",
        children: helpLink.text
      }
    )
  ] });
};
SelectorRadioButton.displayName = COMPONENT_NAME;
export {
  SelectorRadioButton
};
